<template>
  <div class="swiper">
    <nav-top :dataClass="dataClass" :activeIndex = "navIndex"></nav-top>

    <div class="body-swiper">
      <div class="body-container swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide" data-hash="home">
            <home></home>
          </div>
          <div class="swiper-slide" data-hash="about">
            <about></about>
          </div>
          <div class="swiper-slide" data-hash="business">
            <business></business>
          </div>
          <div class="swiper-slide" data-hash="distribution">
            <distribution></distribution>
          </div>
          <div class="swiper-slide" data-hash="contact">
            <contact></contact>
          </div>
        </div>
        <div
          :class="['swiper-pagination body-pagination swiper-pagination-bullets',{'white-pagination':isWhiteP}]"
        >{{activeIndex}}</div>
      </div>
    </div>
    <div class="footer">
      <img src="../assets/govicon.png">
      <span>© 2019 Hunicorn Shipping Co., Ltd.&nbsp;&nbsp;<a href="http://www.miitbeian.gov.cn" target="_blank">粤ICP备15094240号</a></span>
    </div>
  </div>
</template>

<script>
import NavTop from "../components/NavTop";

import Swiper from "swiper";
import Home from "./Home";
import About from "./About";
import Business from "./Business";
import Distribution from "./Distribution";
import Contact from "./Contact";

// import "../assets/animate/swiper.animate.js";
import animate from "script-loader!../assets/animate/swiper.animate.js";

export default {
  name: "Swiper",
  data() {
    return {
      activeIndex: 0,
      navIndex: 0,
      isWhiteP: true,
      dataClass: "white"
    };
  },
  watch: {
    activeIndex(val) {
      this.navIndex = val;

      if (val == 1) {
        this.isWhiteP = false;
      } else {
        this.isWhiteP = true;
      }
      if (val == 1) {
        this.dataClass = "black";
      }else if(val == 2){
        this.dataClass = "black nav-black";
      } else {
        this.dataClass = "white";
      }
    }
  },
  mounted() {
    const _this = this;
    const bodySwiper = new Swiper(".body-container", {
      direction: "vertical",
      pagination: {
        el: ".body-pagination",
        clickable: true,
        renderBullet: function(index, className) {
          const text = (index + 1);
          return (
            `<span class="${className}">0${text}</span>`
          );
        }
      },
      mousewheel: true,
      threshold: 10,
      noSwipingSelector: "a,.map-box",
      hashNavigation: {
        watchState: true
      },
      height: window.innerHeight,
      on: {
        slideChange: function() {
          _this.activeIndex = this.activeIndex;
        },
        init: function() {
          swiperAnimate(this);
        },
        slideChangeTransitionEnd: function() {
          swiperAnimate(this);
        }
      }
    });
    window.onresize = () => {
          const _this = this;
    const bodySwiper = new Swiper(".body-container", {
      direction: "vertical",
      pagination: {
        el: ".body-pagination",
        clickable: true,
        renderBullet: function(index, className) {
          const text = (index + 1);
          return (
            `<span class="${className}">0${text}</span>`
          );
        }
      },
      mousewheel: true,
      threshold: 10,
      noSwipingSelector: "a,.map-box",
      hashNavigation: {
        watchState: true
      },
      height: window.innerHeight,
      on: {
        slideChange: function() {
          _this.activeIndex = this.activeIndex;
        },
        init: function() {

          swiperAnimate(this);
        },
        slideChangeTransitionEnd: function() {
          swiperAnimate(this);
        }
      }
    });
    }
  },
  components: {
    Home,
    NavTop,
    About,
    Business,
    Distribution,
    Contact
  }
};
</script>

<style>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
@import "../assets/animate/animate.css";

.body-swiper .swiper-slide {
  width: 100%;
  height: 100%;
  position: relative;
}
.body-swiper .body-pagination {
  position: fixed;
  top: 50%;
  right: 60px !important;
  transform: translateY(-50%);
  font-size: 30px;
}
span.swiper-pagination-bullet-active {
  background: #000;
  color: rgba(0, 0, 0, 1);
}
.swiper-pagination-bullet {
  color: rgba(255, 255, 255, 0);
  margin: 10px auto !important;
}
.white-pagination span {
  background: #fff;
}
.white-pagination .swiper-pagination-bullet-active {
  color: rgba(255, 255, 255, 1);
}
.body-pagination .swiper-pagination-bullet-active {
  padding-bottom: 70px;
  background: none;
  position: relative;
  text-align: center;
  width: 36px;
}
.body-pagination .swiper-pagination-bullet-active::before {
  content: "";
  display: inline-block;
  /* background: none; */
  background: #000;
  height: 30px;
  width: 2px;
  position: absolute;
  border-radius: 2px;
  bottom: 0;
  left: 50%;
  margin-left: -1px;
}
.white-pagination .swiper-pagination-bullet-active::before {
  background: #fff;
}
.footer{
  position: fixed;
  bottom: 10px;
  right: 32px;
  color: #999;
  font-size: 12px;
  z-index: 9999;
}
.footer img,.footer p{
  vertical-align: middle
}
.footer img{
  width: 20px;
  margin-right: 10px;
}
.footer a {
  color: #999;
  text-decoration: none;
}
.footer a:hover {
  color: #999;
}
@media screen and (max-width: 992px) {
  .body-swiper .swiper-pagination {
    font-size: 18px;
  }
  .swiper-pagination .swiper-pagination-bullet-active {
    padding-bottom: 42px;
  }
  .swiper-pagination .swiper-pagination-bullet-active::before {
    height: 20px;
  }
  .body-swiper .swiper-container-vertical > .swiper-pagination-bullets {
    right: 0px !important;
  }

  .navbar-dark .navbar-toggler{
    padding: 0;
  }
  body .navbar-dark .navbar-toggler-icon {
    background-image: url(../assets/nav-btn.png);
    background-size: 30px;
  }
   body .nav-black .navbar-toggler-icon {
    background-image: url(../assets/nav-btn2.png);
  }
  body .navbar-dark .close .navbar-toggler-icon {
    background-image: url(../assets/close.png);
    background-size: 20px;
  }
  body .swiper-pagination-bullet {
    width: 6px;
    height: 6px;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/SwiperView.vue